<!--  -->
<template>
  <div class="sp_view">
    <div class="tabselecr_box">
      <div class="search_box">
        <!-- <el-input
          v-model="query.suite_id"
          clearable
          style="width:300px;"
          placeholder="请输入应用id"
        /> -->
        <el-input
          v-model="query.keywords"
          clearable
          style="width: 400px; margin: 0 10px"
          placeholder="请输入企业名称/企业id"
        />
        <el-button
          type="primary"
          style="margin-left: 10px"
          icon="el-icon-search"
          @click="searchclick"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="rechargeclick"
        >重置</el-button>
        <el-button
          type="warning"
          icon="el-icon-thumb"
          @click="anthall"
        >授权</el-button>
      </div>
      <div>
        <!-- <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button> -->
      </div>
    </div>
    <el-table ref="multipleTable" v-loading="loading" :data="tableData" border>
      <el-table-column
        prop="corp_name"
        label="企业名称"
        align="center"
        width="350"
      />
      <el-table-column
        prop="corp_type"
        label="授权方企业类型"
        align="center"
        width="130"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.corp_type === 'verified'">认证号</div>
          <div v-if="scope.row.corp_type === 'unverified'">注册号</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="subject_type_text"
        label="企业类型"
        align="center"
        width="100"
      />
      <el-table-column
        prop="corp_id"
        label="企业id"
        align="center"
        width="350"
      />
      <el-table-column
        prop="suite_id"
        label="应用id"
        align="center"
        width="200"
      />
      <el-table-column
        prop="already_upgrade_chat"
        label="群id"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.already_upgrade_chat === '已升级'" style="color: #165DFF;">
            {{ scope.row.already_upgrade_chat }}
          </span>
          <span v-else style="color: #ccc;">
            {{ scope.row.already_upgrade_chat }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
        width="180"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        align="center"
        width="150"
      />
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-dropdown
            trigger="click"
            @command="(command) => handleCommand(command, scope.row)"
          >
            <span class="el-dropdown-link" style="cursor: pointer">
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  type="primary"
                  class="el-button-new"
                  size="mini"
                  :disabled="loadngbool"
                  @click="look(scope.row)"
                >拉取企业员工</el-button>
              </el-dropdown-item>
              <el-dropdown-item command="interiorgroup">
                <el-button
                  type="primary"
                  class="el-button-new"
                  size="mini"
                  @click="interiorGroupPull(scope.row)"
                >内部群拉取</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="primary"
                  class="el-button-new"
                  size="mini"
                  @click="clickConfig(scope)"
                >养号配置</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="primary"
                  class="el-button-new"
                  size="mini"
                  @click="viewDepartment(scope.row.id)"
                >查看部门</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="primary"
                  class="el-button-new"
                  size="mini"
                  @click="load(scope.row.corp_id)"
                >拉取群聊</el-button>
                <el-button
                  type="primary"
                  class="el-button-new"
                  size="mini"
                  style="margin-left: 0px"
                  @click="editadmin(2, scope.row, true)"
                >修改管理员</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="primary"
                  class="el-button-new"
                  size="mini"
                  @click="labelbtn(scope.row.corp_id)"
                >企业标签</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="primary"
                  class="el-button-new"
                  size="mini"
                  @click="handleUpgradeGroupId(scope.row)"
                >升级群ID</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="primary"
                  class="el-button-new"
                  size="mini"
                  @click="copyCallback(scope.row)"
                >复制回调地址</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>

        <!-- <template slot-scope="scope">
          <el-button type="success" size="mini" @click="interiorGroupPull(scope.row)">内部群拉取</el-button>
          <el-button
            type="warning"
            size="mini"
            @click="clickConfig(scope)"
          >养号配置</el-button>
          <el-button
            type="success"
            size="mini"
            @click="viewDepartment(scope.row.id)"
          >查看部门</el-button>

          <el-button
            type="primary"
            size="mini"
            @click="look(scope.row)"
          >拉取企业员工</el-button>
          <el-button
            type="warning"
            size="mini"
            @click="load(scope.row.corp_id)"
          >拉取群聊</el-button>
          <el-button type="danger" size="mini" @click="deteleter(scope.row.customer_message_no)">删除</el-button>
        </template> -->
      </el-table-column>
    </el-table>

    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="选择服务商"
      :visible.sync="choosecontet"
      :append-to-body="true"
      width="20%"
    >
      <el-select v-model="value" placeholder="请选择服务商">
        <el-option
          v-for="item in options"
          :key="item.provider_id"
          :label="item.provider_name"
          :value="item.provider_id"
        />
      </el-select>
      <div style="margin-top: 20px">
        <el-button type="primary" @click="choosesumbit">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="企业授权"
      :visible.sync="lookpassword"
      :append-to-body="true"
      width="30%"
    >
      <div
        v-loading="loadinglink"
        class="qr_box"
        element-loading-background="transparent"
      >
        <img
          v-if="link != ''"
          v-loading="loadinglink"
          :src="link"
          style="width: 200px; height: 200px"
        >
      </div>
    </el-dialog>
    <el-dialog
      center
      title="查看部门"
      style="display: none!imortant"
      :visible.sync="dialogVisible"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <el-row>
        <el-col :span="12" class="lightgreen-box">
          <el-tree
            ref="tree"
            class="admin-access"
            :highlight-current="true"
            :expand-on-click-node="false"
            :check-strictly="true"
            :data="treeList"
            :props="defaultProps"
            @node-click="handleNodeClick"
          />
        </el-col>

        <el-col v-show="dataList.length > 0" :span="12" class="orange-box">
          <el-table border size="mini" :data="dataList" style="width: 55%">
            <el-table-column prop="name" label="姓名" width="100" />
            <el-table-column prop="post" label="职务" width="100" />
          </el-table>
        </el-col>
      </el-row>
      <pagination-right
        v-show="dataList.length > 0"
        :current-page="dataListquery.page"
        :total="dataListquery.total"
        :page-sizes="[10]"
        :page-size="dataListquery.pageSize"
        @size-change="fetchPageSizetree"
        @current-change="fetchCurrentPagetree"
      />
    </el-dialog>
    <el-dialog
      title="管理员"
      :visible.sync="admindialogstatus"
      :append-to-body="true"
      :destroy-on-close="true"
      width="20%"
    >
      <admindialog ref="admindialogview" @updataadmin="updataadmin" />
    </el-dialog>
    <el-dialog
      title="升级群ID"
      :visible.sync="upgradeDialogVisible"
      width="30%"
      :before-close="() => { upgradeDialogVisible = false }"
    >
      <el-form :model="upgradeForm" label-width="80px">
        <el-form-item label="升级时间">
          <el-date-picker
            v-model="upgradeForm.upgrade_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择时间"
            style="width:100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="upgradeDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="upgradeFormLoading"
          @click="handleUpgradeSubmit"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import admindialog from './components/admindialog.vue'
import {
  spCorpViewDepartmentr,
  spCorpViewDepartmentUserList
} from '@/api/officialaccount'
import {
  spCorplist,
  spCorpfetchCorpUsers,
  authPage,
  supplierlist,
  loaddown,
  spWorkWechatSpCorpInternalGroupPull,
  chatIdUpgrade
} from '@/api/officialaccount.js'
export default {
  name: 'Enterprise',
  components: { PaginationRight, admindialog },
  data() {
    return {
      initDataList: {},
      dataList: [],
      dataListquery: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false, // 查看部门开关
      treeList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      options: [],
      value: null,
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        pageSize: 10,
        keywords: null
        // suite_id: null
      },
      link: '',
      loadinglink: false,
      lookpassword: false,
      choosecontet: false,
      admindialogstatus: false,
      labeldialogstatus: false,
      loadngbool: false,
      upgradeDialogVisible: false, // 升级群ID弹窗开关
      upgradeForm: {
        corp_id: null,
        upgrade_time: ''
      },
      upgradeFormLoading: false // 按钮loading
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    handleCommand(command, data) {
      console.log(command, data, '111111')
    },
    // 内部群拉取
    async interiorGroupPull(row) {
      const res = await spWorkWechatSpCorpInternalGroupPull(row.corp_id)
      if (res.code === 200) {
        this.$message({
          message: '拉取成功',
          type: 'success'
        })
      } else {
        this.$message({
          message: res.message,
          type: 'error'
        })
      }

      console.log(res, 'rss')
    },
    // 养号配置
    clickConfig(ev) {
      console.log(ev, 'ev--------', ev.row.id)
      this.$router.push({
        name: 'Paging',
        query: { chatid: ev.row.corp_id, corp_id: ev.row.id }
      })
      // localStorage.setItem('chatid', JSON.stringify(ev.row.id))
      // localStorage.setItem('chat-corp_id', JSON.stringify(ev.row.corp_id))
      // this.$router.push('/EnterChat')
    },
    fetchPageSizetree(e) {
      console.log(1) // 页数 10 5
      this.dataListquery.pageSize = e
      this.changeDataList()
    },
    fetchCurrentPagetree(e) {
      console.log(2) // 第二页 ...
      console.log(e, 'eeee')
      this.dataListquery.page = e
      this.changeDataList()
    },
    async handleNodeClick(data) {
      const list = [data]
      const newlist = await this.traverse(list)
      const department_ids = newlist.join(',')
      const corp_id = list[0].corp_id
      this.initDataList = {
        department_ids: department_ids,
        corp_id: corp_id
      }
      this.changeDataList()
    },
    async changeDataList() {
      const res = await spCorpViewDepartmentUserList({
        corp_id: this.initDataList.corp_id,
        department_ids: this.initDataList.department_ids,
        page: this.dataListquery.page,
        page_size: this.dataListquery.pageSize
      })
      this.dataListquery.total = res.data.count
      this.dataList = res.data.list.map((item) => {
        return {
          name: item.name,
          post: item.position
        }
      })
    },
    // 查看部门
    traverse(arr) {
      let ids = []
      arr.forEach((item) => {
        if (item.id) {
          ids.push(item.id)
        }
        if (item.children && item.children.length) {
          const children = item.children
          ids = ids.concat(this.traverse(children))
        }
      })
      return ids
    },
    async viewDepartment(id) {
      this.dataList = []
      this.treeList = []
      this.dialogVisible = true
      const res = await spCorpViewDepartmentr(id)
      this.treeList = await this.changeTree(res.data.list, 0)
    },
    changeTree(arr, pid) {
      return arr.filter((item) => {
        if (item.parentid === pid) {
          const children = this.changeTree(arr, item.id)
          if (item.children > 0) {
            item.children = children
          }
          return true
        }
      })
    },
    async list() {
      this.loading = true
      const data = await spCorplist(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      // console.log('data', data)
    },
    async look(item) {
      console.log('item', item)
      this.loadngbool = true
      try {
        const data = await spCorpfetchCorpUsers({
          suite_id: item.suite_id,
          corp_id: item.corp_id
        })
        this.$message({
          message: '拉取成功',
          type: 'success'
        })
        console.log('data', data)
      } catch (err) {
        console.log('err', err)
      }
      this.loadngbool = false
    },

    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      // this.query.suite_id = null
      this.query.keywords = null
      this.list()
    },
    choosesumbit() {
      if (this.value === null) {
        this.$message({
          message: '请选择服务商',
          type: 'error'
        })
        return
      }
      this.anth()
      this.choosecontet = false
      this.lookpassword = true
    },
    async anthall() {
      console.log('授权')
      this.value = null
      this.options = []
      this.supplier()
      this.choosecontet = true
    },
    async supplier() {
      const data = await supplierlist()
      this.options = data.data.provider_list

      console.log('data', data.data.provider_list)
    },
    async anth() {
      console.log('授权')
      try {
        this.link = ''
        this.lookpassword = true
        this.loadinglink = true
        const data = await authPage({
          corp_provider_id: this.value
        })
        this.loadinglink = false
        this.link = data.data.qrcode_url
        console.log('data', data.data.qrcode_url)
      } catch {
        this.loadinglink = false
      }
    },
    async load(id) {
      const data = await loaddown({
        corp_id: id
      })
      this.$message({
        message: '拉取群聊成功',
        type: 'success'
      })
      this.menuList()
      console.log('data', data)
    },
    editadmin(type, item, status) {
      this.admindialogstatus = true
      this.$nextTick(() => {
        this.$refs.admindialogview.send(type, item, status)
      })
    },
    updataadmin() {
      this.admindialogstatus = false
      this.list()
    },
    updatlabel() {
      this.labeldialogstatus = false
      this.list()
    },
    // 企业标签
    async labelbtn(id) {
      console.log('企业标签', id)
      this.$router.push({
        query: {
          id: id
        },
        path: '/enterpriselabel/index'
      })
    },
    handleUpgradeGroupId(row) {
      this.upgradeForm.corp_id = row.corp_id
      this.upgradeForm.upgrade_time = ''
      this.upgradeDialogVisible = true
    },
    // 确认升级
    async handleUpgradeSubmit() {
      if (!this.upgradeForm.upgrade_time) {
        this.$message.warning('请选择升级时间')
        return
      }
      this.upgradeFormLoading = true
      try {
        const res = await chatIdUpgrade({
          corp_id: this.upgradeForm.corp_id,
          upgrade_time: this.upgradeForm.upgrade_time
        })
        if (res.code === 200) {
          this.$message.success('升级群ID成功！')
          this.upgradeDialogVisible = false
          this.list() // 刷新主表
        } else {
          this.$message.error(res.message || '升级失败')
        }
      } catch (e) {
        this.$message.error('请求异常')
      }
      this.upgradeFormLoading = false
    },
    copyCallback(row) {
      if (!row.callback_url) {
        this.$message.warning('暂无回调地址')
        return
      }
      // 兼容方案
      if (navigator.clipboard) {
        navigator.clipboard.writeText(row.callback_url)
          .then(() => this.$message.success('复制成功！'))
          .catch(() => this.$message.error('复制失败，请手动复制'))
      } else {
        // fallback
        const input = document.createElement('input')
        input.value = row.callback_url
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message.success('复制成功！')
      }
    }

    // labelbtn(row) {
    //   this.labeldialogstatus = true
    //   console.log('企业标签', row)
    //   this.$nextTick(() => {
    //     this.$refs.labeldialogview.send(row)
    //   })
    // }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view {
  padding: 30px;
}
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.qr_box {
  text-align: center;
}
.element.style {
  position: absolute;
  top: 123px;
  left: 1315px;
}
.el-button-new {
  width: 100%;
}
</style>
